import { combineReducers, Reducer } from 'redux';
import InternationalisationReducer from './reducers/InternationalisationReducers';
import RecruitmentsReducer from './reducers/recruitments';
import StoreArticleReducer from './reducers/storeArticles';
import { ApplicationState } from './types';

const rootReducer: Reducer<ApplicationState> = combineReducers<
  ApplicationState
>({
  i18n: InternationalisationReducer,
  recruitments: RecruitmentsReducer,
  shop: StoreArticleReducer
});

export default rootReducer;
